import React from 'react';
import { Link } from 'react-router-dom';
import Head from '../../components/Head';
import './legal.css';

const PrivacyPolicy = () => {
  return (
    <div className="legal-page">
      <Head title="Privacy Policy" />

      <div className="legal-header">
        <Link to="/" className="legal-back">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5"/><path d="m12 19-7-7 7-7"/></svg>
          Back to home
        </Link>
        <h1>Privacy Policy</h1>
        <p>Last updated: March 5, 2026</p>
      </div>

      <div className="legal-body">
        <h2>Overview</h2>
        <p>
          Your privacy is important to us. It is TextLink's policy to respect your privacy and comply with any applicable law and regulation regarding any personal information we may collect about you, including via our app, TextLink, and its associated services.
        </p>
        <p>
          Personal information is any information about you which can be used to identify you. This includes information about you as a person (such as name, address, and date of birth), your devices, payment details, and even information about how you use an app or online service.
        </p>
        <p>
          In the event our app contains links to third-party sites and services, please be aware that those sites and services have their own privacy policies. After following a link to any third-party content, you should read their posted privacy policy information about how they collect and use personal information. This Privacy Policy does not apply to any of your activities after you leave our app.
        </p>

        <h2>Information We Collect</h2>
        <p>
          Information we collect falls into one of two categories: "voluntarily provided" information and "automatically collected" information.
        </p>
        <p>
          "Voluntarily provided" information refers to any information you knowingly and actively provide us when using our app and its associated services.
        </p>
        <p>
          "Automatically collected" information refers to any information automatically sent by your device in the course of accessing our app and its associated services.
        </p>

        <h3>Log Data</h3>
        <p>
          When you access our servers via our app, we may automatically log the standard data provided by your device. It may include your device's Internet Protocol (IP) address, your device type and version, your activity within the app, time and date, and other details about your usage.
        </p>
        <p>
          Additionally, when you encounter certain errors while using the app, we automatically collect data about the error and the circumstances surrounding its occurrence. This data may include technical details about your device, what you were trying to do when the error happened, and other technical information relating to the problem. You may or may not receive notice of such errors, even in the moment they occur, that they have occurred, or what the nature of the error is.
        </p>
        <p>
          Please be aware that while this information may not be personally identifying by itself, it may be possible to combine it with other data to personally identify individual persons.
        </p>

        <h3>Device Data</h3>
        <p>Our app may access and collect data via your device's in-built tools, such as:</p>
        <ul>
          <li>Phone/SMS</li>
          <li>Notifications</li>
        </ul>
        <p>
          When you install the app or use your device's tools within the app, we request permission to access this information. The specific data we collect can depend on the individual settings of your device and the permissions you grant when you install and use the app.
        </p>

        <h3>Personal Information</h3>
        <p>
          We may ask for personal information — for example, when you subscribe to our newsletter or when you contact us — which may include one or more of the following:
        </p>
        <ul>
          <li>Email</li>
        </ul>

        <h2>Contact Us</h2>
        <p>
          For any questions or concerns regarding your privacy, you may contact us using the following details:
        </p>
        <p>
          <strong>Aleksandar Spremo</strong><br />
          <a href="mailto:aaronb@textlinksms.com">aaronb@textlinksms.com</a>
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
